import React, { ReactNode } from 'react'
import Box from '@mui/material/Box'

const CHILDREN_CONTENT = 'The contained content goes here'

const defaultSx = {
  container: {
    margin: 0,
    padding: '64px 24px 48px 24px',

    '@media screen and (min-width: 768px)': {
      padding: '48px',
    },
  },
}

export interface ResponsiveContainerProps {
  children: ReactNode
  sx?: object
}

/**
 * @param {ResponsiveContainerProps} props
 * @param props.children (required) - All the need components to contain
 */
export const ResponsiveContainer = (props: ResponsiveContainerProps) => {
  return <Box sx={props.sx || defaultSx.container}>{props.children}</Box>
}

ResponsiveContainer.defaultProps = {
  children: CHILDREN_CONTENT,
}
